import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { string, object, number, bool, array } from "prop-types";

import DfpAd from "../../dfp-ad";

import "./storyAds.m.css";

const StoryAds = ({
  slicedStoryCards,
  index,
  adTitle,
  publisherAttributes,
  story,
  scrollIndex,
  isMobile,
  isLiveBlog,
}) => {
  if (isMobile || isLiveBlog) {
    return (
      <React.Fragment>
        {slicedStoryCards.length > 0 && index === 0 && (
          <div styleName={`adslot adslot-300x250`} className="print-adslot">
            <div styleName="advertising">{adTitle}</div>
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_InArticle_300x250" : "News_InArticle_300x250"}
              targetStory={story}
              slotId={`story_${scrollIndex}-inArticle`}
            />
          </div>
        )}
        {slicedStoryCards.length > 1 && index === 1 && (
          <div styleName={`adslot adslot-300x250`} className="print-adslot">
            <div styleName="advertising">{adTitle}</div>
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_InArticle2_300x250" : "News_InArticle2_300x250"}
              targetStory={story}
              slotId={`story_${scrollIndex}-inArticle2}`}
            />
          </div>
        )}
        {slicedStoryCards.length > 2 && index === 2 && (
          <div styleName={`adslot`} className="print-adslot">
            <DfpAd adtype={"mcanvas1x1"} targetStory={story} slotId={`story_${scrollIndex}-mcanvas`} />
          </div>
        )}
        {slicedStoryCards.length > 3 && index > 2 && index % 2 === 0 && (
          <div styleName={`adslot adslot-300x250`} className="print-adslot">
            <div styleName="advertising">{adTitle}</div>
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_InArticle2_300x250" : "News_InArticle2_300x250"}
              targetStory={story}
              slotId={`story_${scrollIndex}_${index}-inArticle2`}
            />
          </div>
        )}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {slicedStoryCards.length > 0 && index === 0 && (
          <div styleName={`adslot adslot-300x250`} className="print-adslot">
            <div styleName="advertising">{adTitle}</div>
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_InArticle2_300x250" : "News_InArticle2_300x250"}
              targetStory={story}
              slotId={`story_${scrollIndex}-inArticle2`}
            />
          </div>
        )}
        {slicedStoryCards.length > 1 && index === 1 && (
          <div styleName={`adslot`} className="print-adslot">
            <DfpAd adtype={"mcanvas1x1"} targetStory={story} slotId={`story_${scrollIndex}-mcanvas`} />
          </div>
        )}
        {slicedStoryCards.length > 3 && index > 2 && index % 2 !== 0 && (
          <div styleName={`adslot adslot-300x250`} className="print-adslot">
            <div styleName="advertising">{adTitle}</div>
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_InArticle2_300x250" : "News_InArticle2_300x250"}
              targetStory={story}
              slotId={`story_${scrollIndex}_${index}-inArticle2`}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
};

StoryAds.propTypes = {
  slicedStoryCards: array,
  index: number,
  adTitle: string,
  publisherAttributes: object,
  story: object,
  scrollIndex: number,
  isMobile: bool,
  isLiveBlog: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(StoryAds);
